import React, { useContext } from "react";
import { FaLock, FaKey, FaExclamationTriangle, FaUserShield } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./loto.jpg";

const LOTO: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/loto');
    } else {
      navigate('/login', { state: { from: '/booking/loto' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Critical Procedure</span>
          <h1 className="hero-title">Lockout / Tagout (LOTO)</h1>
          <p className="hero-subtitle">
            Controlling hazardous energy is a matter of life and death.
            Master the "Fatal Five" causes of accidents and the 7 steps of proper isolation.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">What is LOTO?</h2>
              <p className="article-text">
                Lockout/Tagout refers to specific practices and procedures to safeguard employees
                from the unexpected energization or startup of machinery and equipment, or the
                release of hazardous energy during service or maintenance activities.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The 7 Steps of LOTO</h2>
              <p className="article-text">
                <ol style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Preparation:</strong> Notify affected employees.</li>
                  <li><strong>Shutdown:</strong> Power down equipment normally.</li>
                  <li><strong>Isolation:</strong> Disconnect from energy sources (Valves, Breakers).</li>
                  <li><strong>Lockout:</strong> Apply physical locks and tags.</li>
                  <li><strong>Stored Energy:</strong> Release pressure, tension, or capacitance.</li>
                  <li><strong>Verification:</strong> "Tryout" - Attempt to start to ensure zero energy.</li>
                  <li><strong>Perform Work:</strong> Complete the maintenance task safely.</li>
                </ol>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Common Hazards</h2>
              <p className="article-text">
                Workers often underestimate residual energy. A machine might be unplugged, but
                hydraulic pressure or gravity (raised load) can still cause crushing injuries.
                LOTO ensures <strong>Zero Energy State</strong> before anyone steps inside the danger zone.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Removal Procedure</h2>
              <p className="article-text">
                Unlocking is just as critical. Inspect the area, remove tools, ensure guards are replaced,
                notify employees, and only then remove locks. The person who applied the lock is the
                <strong>only</strong> person authorized to remove it.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">LOTO Essentials</h4>
              <ul className="key-list">
                <li><FaLock className="check-icon" /> Individual Locks</li>
                <li><FaKey className="check-icon" /> One Key, One Person</li>
                <li><FaExclamationTriangle className="check-icon" /> Verify Zero Energy</li>
                <li><FaUserShield className="check-icon" /> Annual Audits</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ borderColor: '#ff4444' }}>
              <h4 className="widget-title" style={{ color: '#ff4444' }}>Warning</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                Working on live equipment is the #1 cause of industrial electrocutions.
                <strong>If it's not locked out, it's not safe.</strong>
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Master LOTO</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Ensure 100% compliance and zero accidents.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default LOTO;
